import { createRouter, createWebHashHistory } from 'vue-router'
import mainComponent from '../components/CorComponent.vue'
import home from '../views/home.vue'
import programs from '../views/programs.vue'
import collegestudents from '../views/collegestudent.vue' 
import stafflist from '../views/stafflist.vue'
import command from '../views/command.vue'
import academicCouncil from'../views/academicCouncil.vue'
import Externalcorrespondence from '../views/Externalcorrespondence.vue'
import statements from '../views/statements.vue'
import Internalcorrespondence from '../views/Internalcorrespondence.vue'
import module from '../views/module.vue'
import group from '../views/group.vue'
import abscence from '../views/abscence.vue'
import evaluations from '../views/evaluations.vue'
import message from '../views/message.vue'
import editStudentInfo from '../views/editStudentInfo.vue'
import editStuff from '../views/editStuff.vue'


import studentregistration from '../views/studentregistration.vue'
import registration from '../views/registration.vue'
import login from '../views/login.vue'
import journal from '../views/journal.vue'
import correspondence from '../views/correspondence.vue'




const routes = [
  {
    path:'/',
    name:'Main',
    component:mainComponent,
    children:[
      {
        path:'/',
        name:'Home',
        component:home,
        meta:{
          requireAuth:true
        }
      },
      
      {
        path:'/programs',
        name:'Programs',
        component:programs,
        meta:{
          requireAuth:true
        }
    },
    {
      path:'/collegestudents',
      name:'collegestudents',
      component:collegestudents,
      meta:{
        requireAuth:true
      }
  },
      {
        path:'/stafflist',
        name:'stafflist',
        component:stafflist,
        meta:{
          requireAuth:true
        }
      },
    
      {
        path:'/command',
        name:'command',
        component:command,
        meta:{
          requireAuth:true
        }

      },
      {
        path:'/academicCouncil',
        name:'academicCouncil',
        component:academicCouncil,
        meta:{
          requireAuth:true
        }

      },
      {
        path:'/Externalcorrespondence',
        name:'Externalcorrespondence',
        component:Externalcorrespondence,
        meta:{
          requireAuth:true
        }

      },

      {
        path:'/statements',
        name:'statements',
        component:statements,
        meta:{
          requireAuth:true
        }

      },
      {
        path:'/Internalcorrespondence',
        name:'Internalcorrespondence',
        component:Internalcorrespondence,
        meta:{
          requireAuth:true
        }

      },

      {
        path:'/module',
        name:'module',
        component: module,
        meta:{
          requireAuth:true
        }

        
      },

      {
        path:'/group',
        name:'group',
        component: group,
        meta:{
          requireAuth:true
        }

        
      },


      {
        path:'/journal',
        name:'journal',
        component: journal,
        meta:{
          requireAuth:true
        }

        
      },

      
      {
        path:'/correspondence',
        name:'correspondence',
        component: correspondence,
        meta:{
          requireAuth:true
        }

        
      },


       

      {
        path:'/abscence',
        name:'abscence',
        component: abscence,
        meta:{
          requireAuth:true
        }

        
      },
      {
        path:'/evaluations',
        name:'evaluations',
        component: evaluations,
        meta:{
          requireAuth:true
        }

        
      },

      {
        path:'/message',
        name:'message',
        component: message,
        meta:{
          requireAuth:true
        }

        
      },
  {
    path:'/registration',
    name:'რეგისტრაცია',
    component:registration,
    meta:{
      requireAuth:true
    }

  },
  {
    path:'/studentregistration',
    name:'სტუდენტის რეგისტრაცია ',
    component:studentregistration,
    meta:{
      requireAuth:true
    }

  },
  {
    path:'/editStudentInfo/:studentID',
    name:'სტუდენტის ინფორმაციის რედაქტირება ',
    component:editStudentInfo,
    meta:{
      requireAuth:true
    }

  },
  {
    path:'/editStuff/:personID',
    name:'თანამშრომლის ინფორმაციის რედაქტირება ',
    component:editStuff,
    meta:{
      requireAuth:true
    }

  }
     
   
    ]
  },
  {
    path:'/login',
    name:'ავტორიზაცია',
    component:login

  } 
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to,from,next)=>{

  if(to.matched.some(record=>record.meta.requireAuth)){
    if(localStorage.getItem('token')){

      next()
    }else{
      next('/login')
    }


  }else{
    next()
  }


})

export default router
